import { environment } from '../environments/environment';

export const BASE_HREF = document.querySelector('head base').getAttribute('href');

export const LANG = BASE_HREF.startsWith('/ru') ? 'ru' : environment.defaultLang;

export const LOCALE_PREFIX = LANG === environment.defaultLang ? '' : `/${LANG}`;

export const DATE_FORMAT = 'DD.MM.YYYY';

export const GOOGLE_ANALYTICS_DATE_FORMAT = 'YYYY-MM-DD';

export const TIME_NO_SEC_FORMAT = 'HH:mm';

export const TIME_ZONE = 'Europe/Kiev';
